import React, { Component } from "react";
import Ink from "react-ink";
import { withRouter } from "react-router-dom";
import { WEBSITE_URL } from "../../../configs/website";


class WebShare extends Component {
  state = {
    shareButton: false,
  };
  componentDidMount() {
    if (navigator.share) {
      this.setState({ shareButton: true });
    }
  }

  shareLink = (link, title) => {
    if (navigator.share) {
      navigator
        .share({
          url: WEBSITE_URL.replace(/\/$/, "") + "/product/" + link,
          text: title,
        })
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.state.shareButton && (
          <button
            type="button"
            className="btn search-navs-btns nav-home-btn"
            style={{
              position: "relative",
              maxWidth: "40px",
              padding: "4px",
              height: "50px",
              marginTop: "2px",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => this.shareLink(this.props.link, this.props.title)}
          >
            {/* <i className="si si-share-alt" /> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-share-3"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M13 4v4c-6.575 1.028 -9.02 6.788 -10 12c-.037 .206 5.384 -5.962 10 -6v4l8 -7l-8 -7z" /></svg>
            <Ink duration="500" />
          </button>
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(WebShare);
